import axios from "axios";
import { log } from "../lib/log";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/audio`;

export const audioApi = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const formatErr = (e) =>
  e?.response?.data?.detail || e?.message || "Something went wrong";

// Convenience: track an analytics event (best-effort, never blocks UI)
export const track = (event_type, extras = {}) => {
  audioApi.post("/events", { event_type, ...extras }).catch((err) => {
    log.debug("[audio] event track failed:", event_type, err?.message || err);
  });
};
